import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import CustomerStory from 'marketing-website/components/modules/CustomerStory';

function ReadMoreBlock({ articles, location }) {
  return (
    <Spacing size="xl" position="topBottom" type="margin">
      <PageWrap>
        <Grid columns={3} size="l" alignItems="center">
          {articles
            .filter(({ url }) => location.pathname !== url)
            .slice(0, 3)
            .map(item => (
              <GridItem
                key={item.id}
                columnSpan={3}
                columnSpanM={1}
                alignContent="center"
              >
                <CustomerStory {...item} />
              </GridItem>
            ))}
        </Grid>
      </PageWrap>
    </Spacing>
  );
}

export default withRouter(ReadMoreBlock);

ReadMoreBlock.propTypes = {
  articles: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/ContentBlocks/ReadMore/index.js